<div class="vincent_about2">
    <div class="row">
        <div class="col col-12 vincent_content">
            <div class="row vincent_reservation" style="flex-direction: row-reverse;">
                <div class="col col-12 vincent_reservation_block ">
                    <div class="relative-bottom">
                        <h3>{{"be_always_with_us" | translate}}</h3>
                        <h1>{{"check_mail" | translate}}</h1>
                        <p class="timer-border">{{timer}}</p>
                        <p *ngIf="showDialog">{{"please_check" | translate}}</p>
                        <p *ngIf="showNotice">{{"session_done" | translate}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>